// auth.js
export const LOGOUT = 'LOGOUT';
export const ON_LOGOUT = 'ON_LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';
export const USER_PUSH_ALLOWED_REQUESTS_IDS = 'USER_PUSH_ALLOWED_REQUESTS_IDS';
export const USER_CHANGE_SIP_STATUS = 'USER_CHANGE_SIP_STATUS';
export const CLEAR_USER_SIP = 'CLEAR_USER_SIP';
export const INIT_LAST_RELOAD = 'INIT_LAST_RELOAD';

export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';

export const REGIONS_SET = 'REGIONS_SET';
export const BANKS_ALL_SET = 'BANKS_ALL_SET';

export const OPERATORS_CALL_CENTER_SET = 'OPERATORS_CALL_CENTER_SET';
export const SALES_MANAGERS_ALL_SET = 'SALES_MANAGERS_ALL_SET';
export const CREDIT_MANAGERS_ALL_SET = 'SALES_MANAGERS_ALL_SET';


export const REQUESTS_FILTER_SET = 'REQUESTS_FILTER_SET';
export const REQUESTS_FILTER_DATA_SET = 'REQUESTS_FILTER_DATA_SET';
export const REQUESTS_FILTER_SALON_SET = 'REQUESTS_FILTER_SALON_SET';
export const REQUESTS_FILTER_SALON_DATA_SET = 'REQUESTS_FILTER_SALON_DATA_SET';
export const REQUESTS_SELECTED_PUSH = 'REQUESTS_SELECTED_PUSH';
export const REQUESTS_SELECTED_PULL = 'REQUESTS_SELECTED_PULL';

export const OPERATIONS_SELECTED_PUSH = 'OPERATIONS_SELECTED_PUSH';
export const OPERATIONS_SELECTED_PULL = 'OPERATIONS_SELECTED_PULL';

export const CAR_WAREHOUSE_SELECTED_PUSH = 'CAR_WAREHOUSE_SELECTED_PUSH';
export const CAR_WAREHOUSE_SELECTED_PULL = 'CAR_WAREHOUSE_SELECTED_PULL';

export const SOURCES_ALL_SET = 'SOURCES_ALL_SET';
export const PLATFORMS_ALL_SET = 'PLATFORMS_ALL_SET';

export const REMINDERS_EXPIRED_SET = 'REMINDERS_EXPIRED_SET';

export const COLUMNS_SET = 'COLUMNS_SET';
export const COLUMNS_PUT_DB = 'COLUMNS_PUT_DB';
export const AFFILIATE_PROGRAM_CATEGORIES_ALL_SET = 'AFFILIATE_PROGRAM_CATEGORIES_ALL_SET';
export const AFFILIATE_SALES_SELECTED_PUSH = 'AFFILIATE_SALES_SELECTED_PUSH';
export const AFFILIATE_SALES_SELECTED_PULL = 'AFFILIATE_SALES_SELECTED_PULL';
